import { Col, Row } from 'react-styled-flexboxgrid';
import Img from 'react-image';
import getPhotos, { SMALL } from '../../../../../helpers/getPhotos';
import { FeaturedTopItem, FeaturedTopTag } from '../../featured.style';
import PlaceholderImage from '@core/ui/static/images/thumb-grid-placeholder.svg';
import Price from '../../../price';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import { slugify } from '../../../../../helpers/urlHandler';
import Link from 'next/link';
import icoLocation from '@core/ui/static/images/ico-location.svg';
import icoBonPlan from '@core/ui/static/images/ico-bon-plan.svg';
import { useTranslation } from 'next-i18next';

const Item = ({ data, ...props }) => {
  const { t } = useTranslation();
  const titleLength = 25;
  const title =
    data.title.substring(0, titleLength) +
    (data.title.length > titleLength ? '...' : '');

  const { media, photos } = data;

  const image = getPhotos(media, photos, SMALL)[0];

  const { contentUrl, height = null, source = null, thumbnail, width = null } =
    image || {};

  const {
    contentUrl: thumbnailContentUrl,
    height: thumbnailHeight = null,
    source: thumbnailSource = null,
    width: thumbnailWidth = null,
  } = thumbnail || {};

  const imgSrc = thumbnail ? thumbnailContentUrl : contentUrl;
  const imgHeight = thumbnail ? thumbnailHeight : height;
  const imgSource = thumbnail ? thumbnailSource : source;
  const imgWidth = thumbnail ? thumbnailWidth : width;

  return (
    <FeaturedTopItem>
      <Row className="item">
        <Col className="media" xs={5}>
          <picture>
            {imgSource}
            {(image && (
              <img
                src={imgSrc}
                alt=""
                width={imgWidth}
                height={imgHeight}
                loading="lazy"
              />
            )) || <img src={PlaceholderImage} alt="" loading="lazy" />}
          </picture>
        </Col>
        <Col className="description" xs={7}>
          <header>
            <FeaturedTopTag>
              <img src={icoBonPlan} alt="Bon plan" />
              <span>{t('pro.recommendation').toUpperCase()}</span>
            </FeaturedTopTag>
          </header>
          <Link
            href={`/${SEARCH_PAGE}/${slugify(data.category)}/${slugify(
              data.title
            )}-${data.sid}`}
          >
            <div className="body">
              <div className="flex flex-col">
                <p className="title">{title}</p>
                <div className="flex flex-row">
                  <div className="wrapper">
                    <Price amount={data.price} />
                  </div>
                  <div className="location">
                    <img src={icoLocation} alt="Localisation" />
                    {data.town && <span>{data.town}</span>}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </Col>
      </Row>
    </FeaturedTopItem>
  );
};

export default Item;
